import { render, staticRenderFns } from "./NotificationMenuDropdown.vue?vue&type=template&id=674a1648&scoped=true&"
import script from "./NotificationMenuDropdown.vue?vue&type=script&lang=ts&"
export * from "./NotificationMenuDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationMenuDropdown.vue?vue&type=style&index=0&id=674a1648&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674a1648",
  null
  
)

export default component.exports